// extracted by mini-css-extract-plugin
module.exports = {"sendingMessage":"sendingMessage--3lUsg","RotateAni":"RotateAni--3zaWF","rotateAni":"RotateAni--3zaWF"};